import React, { useCallback } from 'react'
import { AutoComplete, AutoCompleteDataType, AutoCompleteProps } from 'scenes/Dashboard/components/Inputs/Select'
import { AutoCompleteOption } from 'scenes/Dashboard/components/Inputs/Select/AutoComplete/AutoComplete.model'
import { FieldProps, getIn } from 'utils-next/forms'

export type OrganizationSelectProps = Omit<AutoCompleteProps, 'value' | 'dataType' | 'onCreateOption' | 'onChange'> &
  FieldProps

export function OrganizationSelect({
  field: { name, value },
  form: { setFieldValue, errors },
  ...asyncSelectProps
}: OrganizationSelectProps) {
  const handleChange = useCallback(
    (autoCompleteOption: AutoCompleteOption | '') => {
      if (!autoCompleteOption) {
        setFieldValue(name, '')
        return
      }

      const { value } = autoCompleteOption
      setFieldValue(name, value)
    },
    [name, setFieldValue]
  )

  const parsedValue = value ? { value, display: { label: value.name } } : ''

  return (
    <AutoComplete
      dataType={AutoCompleteDataType.organizations}
      onChange={handleChange}
      value={parsedValue}
      isClearable
      name={name}
      error={getIn(errors, name)}
      {...asyncSelectProps}
    />
  )
}
